export const messagesLeads = {
    pt: {
        message:{
            automationFlow: "Fluxo de Automação",
            dataBase: "Banco de dados",
            false: "Falso",
            importDataBase: "Importar banco de dados",
            manageTableFields: "Gerenciar campos da tabela",
            marketingSend: "Envio para o marketing",
            marketingSends: "Envios para o marketing",
            registerSend: "Cadastrar envio",
            send: "Enviar",
            sendSchedule: "Data e Hora do Envio",
            showMore: "Mostrar mais...",
            tableFields: "Campos da tabela",
            true: "Verdadeiro"
        }
    },
    es: {
        message:{
            automationFlow: "Flujo de automatización",
            dataBase:"Banco de datos",
            false: "Falso",
            importDataBase:"Importar base de datos",
            manageTableFields: "Administrar campos de tabla",
            marketingSend: "Envío para marketing",
            marketingSends: "Envíos para marketing",
            registerSend: "Registro de envío",
            send: "Mandar",
            sendSchedule: "Fecha y hora de envío",
            showMore: "Mostrar más...",
            tableFields: "Campos de tabla",
            true: "Verdadero"
        }
    },
    en: {
        message:{
            automationFlow: "Automation Flow",
            dataBase: "Database",
            false: "False",
            importDataBase: "Import database",
            manageTableFields: "Manage table fields",
            marketingSend: "Marketing Send",
            marketingSends: "Marketing Sends",
            registerSend: "Create send",
            send: "Send",
            sendSchedule: "Date and Time",
            showMore: "Show more...",
            tableFields: "Table fields",
            true: "True"
        }
    }
}
